import React from "react";
import { useCheckViewPoint } from "hooks/useCheckViewPoint";

// Define supported breakpoints
export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl";

export interface ResponsiveLayoutProps {
  children: React.ReactNode;
}

const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <>{children}</>;
};

const ViewPoint: React.FC<{ from?: Breakpoint; to?: Breakpoint; children?: React.ReactNode }> = ({
  from,
  to,
  children,
}) => {
  const isActive = useCheckViewPoint({ from, to });

  return isActive ? <>{children}</> : null;
};

// Placeholder export for variant keys if needed
export const Responsive = {
  View: ViewPoint,
  Layout: ResponsiveLayout,
};
